'use strict';

var prefix = '@@reactReduxFirebase/';

module.exports = {
  START: prefix + 'START',
  SET: prefix + 'SET',
  SET_PROFILE: prefix + 'SET_PROFILE',
  LOGIN: prefix + 'LOGIN',
  LOGOUT: prefix + 'LOGOUT',
  LOGIN_ERROR: prefix + 'LOGIN_ERROR',
  NO_VALUE: prefix + 'NO_VALUE',
  UNAUTHORIZED_ERROR: prefix + 'UNAUTHORIZED_ERROR',
  INIT_BY_PATH: prefix + 'INIT_BY_PATH',
  AUTHENTICATION_INIT_STARTED: prefix + 'AUTHENTICATION_INIT_STARTED',
  AUTHENTICATION_INIT_FINISHED: prefix + 'AUTHENTICATION_INIT_FINISHED'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-firebasev3/build/constants.js
 ** module id = 228
 ** module chunks = 0
 **/